module.exports = __webpack_public_path__ + "img/lottery_1248.86e80db7.png";